/**
 * Welcome popup controller: opens #welcome-popup once per browser after 12s or on desktop exit intent.
 * Re-opens immediately when the page loads after a signup (success or error) from the popup form.
 */
const KEY = 'cn-welcome-seen';
const dialog = document.getElementById('welcome-popup');

function seen() {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return true;
  }
}
function markSeen() {
  try {
    localStorage.setItem(KEY, '1');
  } catch {}
}
function open() {
  if (!dialog || dialog.open || document.querySelector('dialog[open]')) return;
  markSeen();
  dialog.showModal();
}

if (dialog) {
  const postedHere = dialog.querySelector('[data-welcome-success], [role="alert"]');
  if (postedHere) {
    markSeen();
    dialog.showModal();
  } else if (!seen()) {
    const timer = setTimeout(open, 12000);
    if (window.matchMedia('(any-hover: hover)').matches) {
      document.addEventListener('mouseout', function onLeave(e) {
        if (e.relatedTarget || e.clientY > 10) return;
        clearTimeout(timer);
        document.removeEventListener('mouseout', onLeave);
        open();
      });
    }
  }

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) dialog.close();
    const copy = e.target.closest('[data-copy-code]');
    if (!copy) return;
    navigator.clipboard?.writeText(copy.dataset.copyCode).then(() => {
      const label = copy.textContent;
      copy.textContent = copy.dataset.copiedLabel || 'Copied';
      setTimeout(() => (copy.textContent = label), 2000);
    });
  });
}
